import { Text } from '@velocity/ui'
import * as React from 'react'

import {
  type DateFieldProps,
  type FormFieldWrapper,
  type TimeFieldProps,
  type TimeSlotFieldProps,
} from '@ngb-frontend/shared/types'
import { isTimeSlotFieldProps } from '@ngb-frontend/shared/utils'

import { useDateTimeFieldStyles } from './DateTimeField.styled'
import { DateField } from '../DateField/DateField'
import { FlexBox } from '../FlexBox/FlexBox'
import { TimeField } from '../TimeField/TimeField'
import { TimeSlotField } from '../TimeSlotField/TimeSlotField'

export interface DateTimeFieldProps extends Pick<FormFieldWrapper, 'label'> {
  showTimeField?: boolean
  hint?: string
  inline?: boolean
  // TODO: Investigate if warning and required can be part of the date|timeProps
  // instead of passing separately
  warning?: string
  dateProps?: DateFieldProps
  timeProps?: TimeFieldProps | TimeSlotFieldProps
}

export const DateTimeField: React.FC<DateTimeFieldProps> = ({
  hint,
  showTimeField,
  inline,
  label,
  dateProps,
  timeProps,
  warning,
}) => {
  const classes = useDateTimeFieldStyles({ inline })

  return (
    <>
      <FlexBox flexDirection={inline ? 'row' : 'column'}>
        <Text variant="100" bold>
          {label}
        </Text>
        <Text
          component="div"
          margin={{ bottom: !hint && !warning ? '07' : undefined }}
          className={classes.date}
        >
          <DateField
            {...dateProps}
            hideLabel={!dateProps?.label}
            renderKey={
              dateProps?.renderKey || (dateProps?.required ? 'd1' : 'd0')
            }
            warning={!!warning}
            noMargin
          />
        </Text>
        {showTimeField && (
          <Text
            component="div"
            margin={{ bottom: !hint && !warning ? '07' : undefined }}
            className={classes.time}
          >
            {isTimeSlotFieldProps(timeProps) ? (
              <TimeSlotField
                {...timeProps}
                noMargin
                renderKey={
                  timeProps?.renderKey || (timeProps?.required ? 't1' : 't0')
                }
              />
            ) : (
              <TimeField
                {...timeProps}
                hideLabel={!timeProps?.label}
                renderKey={
                  timeProps?.renderKey || (timeProps?.required ? 't1' : 't0')
                }
                warning={!!warning}
                noMargin
              />
            )}
          </Text>
        )}
      </FlexBox>
      {hint && (
        <Text
          variant="100"
          margin={{ top: '02', bottom: !warning ? '07' : undefined }}
        >
          {hint}
        </Text>
      )}
      {warning && <Text margin={{ top: '02', bottom: '07' }}>{warning}</Text>}
    </>
  )
}
